
import {defineComponent} from "vue";
import {Exception} from "@/api/interfaces";
import store from "@/store";
import {mapGetters} from "vuex";
import {DpException} from "@/exception/DpException";
import CbFormTextWithTitle from "@/components/layouts/content-blocks/forms/CbFormTextWithTitle.vue";
import {cnkCodesArrayIsValid} from "@/helpers/functions/products";
import ProductList from "@/components/UI/product/ProductList.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";
import {ProductListSelectionDto} from "@/components/UI/product/ProductListSelectionDto";

export default defineComponent({
  name: "ProductsInTheSpotlight",
  components: {ProductList, CbFormTextWithTitle},
  data: () => ({
    isReady: false as Boolean,
    filterCode: 'PRODUCTS_IN_THE_SPOTLIGHT',
    error: null,
    exceptions: [] as Exception[],
    savedSuccessfully: false as Boolean,
    maxProductsInTheSpotlight: 20 as Number,
    productsInTheSpotlight: {
      cnkCodes: [],
      productCodes: []
    } as ProductListSelectionDto,
  }),
  mounted() {
    this.reloadContent();
  },
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    },
    ...mapGetters(['getCurrentCustomerCode']),
    ...mapGetters('cpc_mgmt', ['getCnkListProductFilter']),
    currentCustomerCode(): String {
      return this.getCurrentCustomerCode;
    },
    productsInTheSpotlightSelection: {
      get(): ProductListSelectionDto {
        return this.productsInTheSpotlight;
      },
      set(value: ProductListSelectionDto) {
        this.productsInTheSpotlight = value;
      }
    }
  },
  methods: {
    submitData() {
      this.saveProductsInTheSpotlight();
    },
    async reloadContent() {
      try {
        this.isReady = false;

        await this.searchProductFilter();
        this.productsInTheSpotlight = {
          cnkCodes: this.getCnkListProductFilter.cnk_codes || [],
          productCodes: this.getCnkListProductFilter.product_codes || []
        };

        this.isReady = true;
      } catch (exceptions: any) {
        this.exceptions = exceptions;
      }
    },
    async saveProductsInTheSpotlight() {
      this.isReady = false;

      try {
        const cnkCodesArray = this.productsInTheSpotlight.cnkCodes || [];
        const productCodesArray = this.productsInTheSpotlight.productCodes || [];
        const totalProducts = cnkCodesArray.length + productCodesArray.length;

        if (totalProducts > this.maxProductsInTheSpotlight) {
          this.isReady = true;
          //TODO: ASK proper vue error handling
          this.exceptions = [new DpException(this.$t('errorTooManyProductsInTheSpotlight'))];
        } else if (!cnkCodesArrayIsValid(cnkCodesArray)) {
          this.isReady = true;
          //TODO: ASK proper vue error handling
          this.exceptions = [new DpException(this.$t('exceptionOnlyNumbersCnk'))];
        } else {
          await store.dispatch('cpc_mgmt/saveCnkListProductFilter', {
            body: cnkCodesArray,
            filter_code: this.filterCode,
          });

          await this.reloadContent().then(() => {
            this.exceptions = [];
            this.savedSuccessfully = true;
            setTimeout(() => this.savedSuccessfully = false, 2000);
          });
        }
      } catch (exceptions: any) {
        this.isReady = true;
        this.exceptions = exceptions;
      }
    },
    async searchProductFilter() {
      try {
        await store.dispatch('cpc_mgmt/searchCnkListProductFilter', this.filterCode)
      } catch (exceptions: any) {
        this.exceptions = exceptions;
      }
    },
  }
});
